import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import PasswordInput from 'components/inputs/PasswordInputField';
import { H5 } from 'components/typography/Headers';
import { useChangePasswordForm } from 'features/my-profile/password/hooks/useChangePasswordForm';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  margin-top: 24px;
`;

const PasswordInputContainer = styled.div<{ $marginType?: 'large' | 'small' }>`
  margin: ${props => (props.$marginType === 'large' ? '24px 0' : '0 0 10px 0')};
`;

export const PasswordChangeForm = () => {
  const { t } = useTranslation('myProfile');
  const { values, handleChange, submitForm, errors, isValid, isSubmitting, dirty } = useChangePasswordForm();

  return (
    <Container>
      <H5>{t('password.form-header')}</H5>

      <PasswordInputContainer $marginType='large'>
        <PasswordInput
          testId={'current-password'}
          value={values.currentPassword}
          placeholder={t('password.input.placeholder-current')}
          onChange={handleChange('currentPassword')}
          errorMessage={errors.currentPassword}
        />
      </PasswordInputContainer>

      <PasswordInputContainer>
        <PasswordInput
          testId={'new-password'}
          value={values.newPassword}
          placeholder={t('password.input.placeholder-new')}
          onChange={handleChange('newPassword')}
          errorMessage={errors.newPassword}
        />
      </PasswordInputContainer>

      <PasswordInputContainer>
        <PasswordInput
          testId={'confirmed-new-password'}
          value={values.newPasswordConfirmation}
          placeholder={t('password.input.placeholder-confirm')}
          onChange={handleChange('newPasswordConfirmation')}
          errorMessage={errors.newPasswordConfirmation}
        />
      </PasswordInputContainer>

      <RedButton data-testid={'password-button'} onClick={submitForm} disabled={!dirty || !isValid || isSubmitting}>
        {t('password.button')}
      </RedButton>
    </Container>
  );
};
